<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div>
        <v-row
          align="center"
          class="pa-0 ma-0 cursor-pointer"
          :class="hover ? 'green lighten-5' : ''"
          @click="show_details = !show_details"
        >
          <v-col cols="3" class="pl-2">
            <v-icon
              size="20"
              class="mr-4"
              :color="isConnected ? 'green' : 'grey'"
              >mdi-propane-tank</v-icon
            >
            <span
              style="font-size: 16px"
              :class="isConnected ? '' : 'grey--text text--lighten-1'"
              >{{ tank.nome }}</span
            >
            <v-tooltip v-if="!isConnected" top>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="grey--text text--lighten-1 ml-2"
                  >(Disconnesso)</span
                >
              </template>
              {{ last_update }}
            </v-tooltip>
          </v-col>
          <v-col cols="2">{{ nome_tipo }} </v-col>
          <v-col cols="1"> {{ capacit.toFixed(0) }} Litri </v-col>
          <v-col cols="1">
            <b>{{
              isConnected
                ? tank.temp_lettura
                  ? tank.temp_lettura.toFixed(1)
                  : "N/A"
                : "N/A"
            }}</b>
          </v-col>
          <v-col cols="1">
            <b>{{ isConnected ? tank.altezza_liquido.toFixed(0) : "N/A" }}</b>
            cm
          </v-col>
          <v-col cols="1">
            <b>{{ isConnected ? tank.volume_liquido.toFixed(0) : "N/A" }}</b>
            Litri
          </v-col>
          <v-col cols="2">
            <v-progress-linear
              :value="isConnected ? percentuale_riemp : 0"
              height="30"
              color="indigo"
            >
              <span class="white--text"
                ><strong
                  >{{
                    isConnected ? percentuale_riemp.toFixed(0) : "N/A"
                  }}
                  %</strong
                ></span
              >
            </v-progress-linear>
          </v-col>
          <v-col cols="1" class="">
            <v-btn icon  color="purple" small @click="$refs.tank_graph.open()"
              ><v-icon>mdi-chart-line</v-icon></v-btn
            >
            <TankGraph :tank="tank" ref="tank_graph" />
            <v-btn
              icon
              small
              v-show="hover"
              color="blue"
              class="ml-2"
              @click="read_request"
            >
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <v-snackbar
              v-model="snackbar_richiesta"
              :timeout="3000"
              bottom
              color="green"
            >
              <v-icon left>mdi-information</v-icon>
              Richiesta di lettura inviata
            </v-snackbar>
            <v-dialog v-model="dialog" max-width="600">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  small
                  v-on="on"
                  v-show="hover"
                  color="blue"
                  class="ml-4"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="d-flex align-center">
                  <v-icon color="indigo" class="mr-2">mdi-tune-vertical</v-icon>
                  <span class="text-h6">Modifica Parametri Cisterna</span>
                </v-card-title>
                <v-card-subtitle class="pt-0">
                  Aggiorna i parametri geometrici e di lettura
                </v-card-subtitle>
                <v-divider />
                <v-card-text class="pt-4">
                  <v-container class="pa-0">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          label="Nome"
                          v-model="nome"
                          prepend-icon="mdi-tag"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-select
                          dense
                          outlined
                          hide-details
                          label="Tipo"
                          v-model="tipo"
                          :items="tanks_type"
                          item-value="value"
                          item-text="text"
                          prepend-icon="mdi-shape"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          label="Altezza"
                          v-model="altezza"
                          type="number"
                          suffix="cm"
                          prepend-icon="mdi-arrow-expand-vertical"
                        />
                      </v-col>
                      <template v-if="tipo == 1">
                        <v-col cols="12" md="6">
                          <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Larghezza"
                            v-model="larghezza"
                            type="number"
                            suffix="cm"
                            prepend-icon="mdi-arrow-expand-horizontal"
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Profondità"
                            v-model="profond"
                            type="number"
                            suffix="cm"
                            prepend-icon="mdi-arrow-collapse-down"
                          />
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12" md="6">
                          <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Diametro"
                            v-model="diametro"
                            type="number"
                            suffix="cm"
                            prepend-icon="mdi-circle-outline"
                          />
                        </v-col>
                      </template>
                      <v-col cols="12">
                        <v-subheader class="px-0"
                          >Parametri sensore</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          label="Densità liquido"
                          v-model="densita_liquido"
                          type="number"
                          suffix="kg/L"
                          prepend-icon="mdi-water"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          label="Offset ADC"
                          v-model="offset_adc"
                          type="number"
                          prepend-icon="mdi-waveform"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          label="Scala ADC"
                          v-model="scala_adc"
                          type="number"
                          prepend-icon="mdi-chart-line"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-subheader class="px-0"
                          >Parametri comunicazione</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          label="Intervallo lettura"
                          v-model="intervallo_lettura"
                          type="number"
                          suffix="ore"
                          prepend-icon="mdi-timer"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          label="Intervallo ping server"
                          v-model="intervallo_ping_server"
                          type="number"
                          suffix="secondi"
                          prepend-icon="mdi-wifi-check"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog_elimina" width="600">
                    <template v-slot:activator="{ on }">
                      <v-btn outlined color="red" v-on="on"
                        ><v-icon class="mr-2">mdi-delete</v-icon>Elimina</v-btn
                      >
                    </template>
                    <v-card>
                      <v-card-title class="red--text">Elimina</v-card-title>
                      <v-card-text> Sei sicuro ? </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn outlined color="red" @click="delete_tank()"
                          ><v-icon class="mr-2">mdi-delete</v-icon
                          >Elimina</v-btn
                        >
                        <v-btn text color="grey" @click="dialog_elimina = false"
                          >Annulla</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn text color="grey" @click="dialog = false"> OK </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <!-- Riga aggiuntiva con informazioni tecniche -->
        <v-expand-transition>
          <v-row
            v-show="show_details"
            class="pa-0 ma-0 grey lighten-4"
            align="center"
          >
            <v-col cols="12" class="py-1 px-4">
              <v-row dense align="center">
                <v-col cols="auto" class="caption grey--text text--darken-1">
                  <v-icon small class="mr-1">mdi-waveform</v-icon>
                  <span class="font-weight-medium">Lettura raw:</span>
                  <span class="ml-1">{{ tank.lettura_raw || "N/A" }}</span>
                </v-col>
                <v-divider vertical class="mx-2"></v-divider>
                <v-col cols="auto" class="caption grey--text text--darken-1">
                  <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                  <span class="font-weight-medium">Ultima lettura:</span>
                  <span class="ml-1">{{ formatted_last_reading }}</span>
                </v-col>
                <v-divider vertical class="mx-2"></v-divider>
                <v-col cols="auto" class="caption grey--text text--darken-1">
                  <v-icon small class="mr-1">mdi-connection</v-icon>
                  <span class="font-weight-medium">Ultimo ping:</span>
                  <span class="ml-1">{{ last_update }}</span>
                </v-col>
                <v-divider vertical class="mx-2"></v-divider>
                <v-col cols="auto" class="caption grey--text text--darken-1">
                  <v-icon small class="mr-1">mdi-signal</v-icon>
                  <span class="font-weight-medium">Segnale:</span>
                  <span class="ml-1">{{
                    tank.wifi_rssi ? tank.wifi_rssi + " dBm" : "N/A"
                  }}</span>
                </v-col>
                <v-divider vertical class="mx-2"></v-divider>
                <v-col cols="auto" class="caption grey--text text--darken-1">
                  <v-icon small class="mr-1">mdi-wifi</v-icon>
                  <span class="font-weight-medium">Wifi:</span>
                  <span class="ml-1">{{ tank.wifi_ssid || "N/A" }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-expand-transition>
      </div>
    </v-hover>
  </div>
</template>

<script>
import tank_element_mixin from "../mixin/tank_element_mixin";
// import _ from "lodash";
// import moment from "moment";
import TankGraph from "./tank_graph_desktop.vue";
export default {
  components: {
    TankGraph,
  },
  mixins: [tank_element_mixin],
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>